import styled from "styled-components";

export const BlogContainer = styled.div`
  min-height: 800px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #f9fafb;
  padding: 40px 20px;

  @media screen and (max-width: 768px) {
    min-height: 1000px;
  }

  @media screen and (max-width: 480px) {
    min-height: 1200px;
  }
`;

export const BlogWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 24px;
  padding: 0 20px;

  @media screen and (max-width: 1000px) {
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  }

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const BlogH1 = styled.h1`
  font-size: 2.5rem;
  color: #1f2937;
  margin-bottom: 48px;
  text-align: center;

  @media screen and (max-width: 480px) {
    font-size: 2rem;
  }
`;

export const BlogCard = styled.div`
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  border-radius: 10px;
  max-width: 300px;
  padding: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  transition: all 0.2s ease-in-out;
  position: relative;

  &:hover {
    transform: scale(1.02);
    transition: all 0.2s ease-in-out;
    cursor: pointer;
  }
`;

export const BlogImage = styled.img`
  height: 160px;
  width: 100%;
  object-fit: cover;
  margin-bottom: 10px;
  border-radius: 10px;
`;

export const BlogTitle = styled.h2`
  font-size: 1.5rem;
  color: #1f2937;
  margin-bottom: 10px;
  text-align: center;
`;

export const BlogDescription = styled.p`
  font-size: 0.9rem;
  color: #4b5563;
  text-align: center;
  margin-bottom: 10px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
`;

export const BlogFooter = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`;

export const BlogAuthor = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const Avatar = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 2px solid #fff;
`;

export const BlogMeta = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.8rem;
  color: #6b7280;
  width: 100%;

  span:last-child {
    margin-left: auto;
  }
`;

export const LikeButton = styled.button`
  display: flex;
  align-items: center;
  gap: 5px;
  background: none;
  border: none;
  color: ${(props) => (props.liked ? "#ef4444" : "#4b5563")};
  cursor: pointer;
  font-size: 0.8rem;

  svg {
    fill: ${(props) => (props.liked ? "#ef4444" : "none")};
    stroke: currentColor;
    width: 20px;
    height: 20px;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const CommentLink = styled.button`
  background: none;
  border: none;
  color: #4b5563;
  cursor: pointer;
  font-size: 0.8rem;
  text-align: right;
`;

export const CommentForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`;

export const NameInput = styled.input`
  padding: 8px;
  border: 1px solid #d1d5db;
  border-radius: 5px;
  font-size: 0.8rem;
  width: 100%;
`;

export const CommentInput = styled.textarea`
  flex: 1;
  padding: 8px;
  border: 1px solid #d1d5db;
  border-radius: 5px;
  font-size: 0.8rem;
  min-height: 60px;
  resize: vertical;
  font-family: inherit;
`;

export const CommentButton = styled.button`
  padding: 8px 12px;
  background: #010606;
  color: #fff;
  border: none;
  border-radius: 5px;
  font-size: 0.8rem;
  cursor: pointer;
  align-self: flex-end;

  &:disabled {
    background: #6b7280;
    cursor: not-allowed;
  }
`;

export const CommentList = styled.div`
  max-height: 200px;
  overflow-y: auto;
  width: 100%;
  margin-top: 10px;
`;

export const Comment = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 0.8rem;
  color: #4b5563;
  border-top: 1px solid #e5e7eb;
  padding: 8px 0;
  margin: 0;
`;

export const CommentText = styled.p`
  flex: 1;
  margin: 0;
  font-size: 0.8rem;
  line-height: 1.4;
`;

export const CommentAvatar = styled.img`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px solid #e5e7eb;
  flex-shrink: 0;
`;

export const CommentAuthor = styled.div`
  font-weight: bold;
  font-size: 0.7rem;
  margin-bottom: 2px;
  color: #1f2937;
`;

export const CommentDate = styled.div`
  font-size: 0.6rem;
  color: #9ca3af;
  margin-top: 2px;
`;

export const Loading = styled.div`
  text-align: center;
  font-size: 1.2rem;
  color: #6b7280;
  padding: 20px;
`;

export const Error = styled.div`
  text-align: center;
  font-size: 1rem;
  color: #ef4444;
  padding: 20px;
`;

export const NoBlogsMessage = styled.div`
  text-align: center;
  grid-column: 1 / -1;
  font-size: 1.1rem;
  color: #6b7280;
  padding: 40px;
  background: #f9fafb;
  border-radius: 10px;
  margin: 20px 0;
`;
